import React, { useCallback } from 'react'
import { filterBlockByType } from '../../../services/common'
import { icon } from '../../../services/icon'
import { Parser } from '../../common'
import Dropdown from '../dropdown/Dropdown'

const ChapterItem = ({ block, index, setOpenSubChapter, openSubChapter }) => {
    const blockTitle = filterBlockByType(block?.childrens, 'Titre')

    const blockWithoutTitle = block?.childrens.filter((children) => children?.block !== 'Titre')

    const onClickOpenSubChapter = useCallback(() => {
        setOpenSubChapter({
            index: openSubChapter?.index?.includes(index)
                ? openSubChapter?.index?.filter((i) => i !== index)
                : [...openSubChapter?.index, index],
        })
    }, [index, openSubChapter, setOpenSubChapter])

    const renderIcon = () =>
        block?.attributes?.numerote === 'true' ? (
            <span className="baseocom-arrow-figure baseocom-w-max baseocom-h-max baseocom-text-base baseocom-inline-flex baseocom-justify-center baseocom-items-center baseocom-text-white">
                {index + 1}
            </span>
        ) : (
            <span className="baseocom-arrow">{icon('arrow-right')}</span>
        )

    const renderByStyleBlock = useCallback(() => {
        switch (block?.style) {
            case 'plain_text':
                return (
                    <div className="baseocom-chapter-block-plain-text">
                        <Parser content_block={block?.childrens} />
                    </div>
                )
            default:
                return (
                    <Dropdown
                        onClickOpen={onClickOpenSubChapter}
                        beforeIcon={renderIcon}
                        title={blockTitle?.content}
                        index={index}
                        className="baseocom-chapter-item"
                        isOpen={openSubChapter}
                        variable={`chapter-${block.ID}-dropdown-height`}
                    >
                        <div className="baseocom-content">
                            <Parser content_block={blockWithoutTitle} />
                        </div>
                    </Dropdown>
                )
        }
    }, [block, index, openSubChapter])

    return renderByStyleBlock()
}

export default ChapterItem
